import React from "react";
import ProfileAvatar from "./ProfileAvatar";
import useAuth from "../../../../hooks/useAuth";
import ProfileForm from "./ProfileForm";
import { useTranslation } from "react-i18next";
import { useGetEntityUser } from "../../../../hooks/users";

const ProfileBasicInfo = () => {
  const { t } = useTranslation();
  const { customer_identification, user } = useAuth();

  const { data, isLoading, isError, isSuccess } = useGetEntityUser({
    customer_identification: customer_identification,
    entityIdentification: user.entity_identification,
    user_identification: user.user_identification as string,
  });
  let content;

  if (isLoading) content = <p>Loading...</p>;

  if (isError) content = <p>Failed to load data.</p>;

  if (isSuccess) {
    content = (
      <React.Fragment>
        <ProfileAvatar
          avatar={data?.user_avatar}
          entity_identification={user.entity_identification}
          customerId={data?.user_identification}
        />

        <ProfileForm
          data={data}
          entity_identification={user.entity_identification}
        />
      </React.Fragment>
    );
  }

  return (
    <div className="p-5 bg-white rounded-lg border border-gray-200 flex-col justify-start items-start gap-5 inline-flex">
      <div className="self-stretch h-14 flex-col justify-start items-start gap-2 flex">
        <div className="text-gray-700 text-lg font-semibold font-figtree leading-7">
          {t("dashboard.profile.key2")}
        </div>
        <div className="text-gray-700 text-sm font-normal font-figtree leading-tight">
          {t("dashboard.profile.key3")}
        </div>
      </div>

      {content}
    </div>
  );
};

export default ProfileBasicInfo;
